import React from 'react';
import { PanelMediaImage, PanelMediaVideo, } from '../components/PanelMedia';
export const selectCorrectMedia = ({ image, videoId }) => {
    if (videoId) {
        return React.createElement(PanelMediaVideo, { id: videoId });
    }
    if (image) {
        return React.createElement(PanelMediaImage, Object.assign({}, image, { fallbackImage: image.fallback }));
    }
    return null;
};
//# sourceMappingURL=selectCorrectMedia.js.map